import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 12\" id=\"star\"><path d=\"m12.8 5.23-2.43 2.48.57 3.5a.71.71 0 0 1-.25.66.61.61 0 0 1-.68.05L7 10.27l-3.02 1.65c-.21.12-.48.1-.67-.05-.2-.15-.3-.4-.26-.66l.58-3.5-2.44-2.48a.677.677 0 0 1-.16-.69c.07-.25.27-.42.51-.46l3.37-.51L6.42.38C6.53.15 6.75 0 7 0c.24 0 .46.15.57.38l1.51 3.19 3.37.51c.24.04.44.21.52.46.07.24.01.51-.17.69Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol